<template lang="pug">
  v-layout(justify-center)
    v-flex(xs12)
      v-layout(justify-start)
        h2(class="card__title") {{$t('common.requisites')}}
      v-data-table(
        :headers="headers",
        :items="profile",
        :loading="loading",
        :no-data-text="$t('common.noDataText')",
        hide-actions)
        template(slot="items" slot-scope="props")
          td {{ props.index + 1 }}
          td {{ props.item.name }}
          td {{ props.item.value }}
</template>

<script>
import axios from 'axios'
export default {
  name: 'Profile',
  data: () => ({
    profile: [],
    fetchError: '',
    loading: true
  }),
  mounted() {
    this.getProfile()
  },
  methods: {
    getProfile() {
      axios({
        method: 'GET',
        url: '/api/user/GetProfile'
      })
        .then(response => {
          this.profile = response.data.result
          this.fetchError = ''
          this.loading = false
        })
        .catch(error => {
          this.fetchError = error
          this.loading = false
        })
    }
  },
  computed: {
    headers() {
      return [
        {
          text: '№',
          sortable: false,
          value: 'index'
        },
        {
          text: this.$t('ReportingPage.SortForm.nameForm'),
          sortable: false,
          value: 'name'
        },
        {
          text: this.$t('ReportingPage.SortForm.moreList'),
          sortable: false,
          value: 'value'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainPage/components/Profile/Profile.vue